import { useSelector } from 'react-redux'
import { SettingsSelect } from 'apps/studio/components/settings/inputs/SettingsSelect'
import { slugify } from 'apps/builder/lib/utils'

import {
  eligibleDependentEntriesSelector,
  dataSourceContextParamsSelector,
} from 'apps/formsCreationKit/store/selectors/entities'

import {
  createDataSourceParam,
  updateDataSourceParam,
} from 'apps/formsCreationKit/store/actions/sharedActions'

const ParamMappingSelect = ({
  settingId,
  settingLabel,
  dataSourceParamId,
  dataSourceContextId,
  isDisabled = false,
  isLast,
}) => {
  const dataSourceParams = useSelector(dataSourceContextParamsSelector)
  const dependentEntryScreens = useSelector(eligibleDependentEntriesSelector)
  const options = dependentEntryScreens.map(({ screenLabel, entries }) => ({
    label: screenLabel,
    options: entries
      .filter(
        ({ data_source_context_id }) =>
          data_source_context_id !== dataSourceContextId
      )
      .map(({ label, id }) => ({
        label,
        value: id,
      })),
  }))
  const NoneOption = {
    label: 'None',
    options: [
      {
        label: 'None',
        value: null,
      },
    ],
  }

  const mappedParam =
    dataSourceParams.find(
      param =>
        param.data_source_param_id === dataSourceParamId &&
        param.data_source_context_id === dataSourceContextId
    ) || {}

  const update = ({ id }) => {
    const payload = {
      data_source_context_id: dataSourceContextId,
      data_source_param_id: dataSourceParamId,
      id: mappedParam.id,
      entry_id: id,
    }

    const updateMethod = mappedParam.id
      ? updateDataSourceParam
      : createDataSourceParam

    return updateMethod(payload)
  }

  return (
    <SettingsSelect
      id={settingId}
      isDisabled={isDisabled}
      label={settingLabel}
      choices={[NoneOption, ...options]}
      size="large"
      className={
        isLast ? 'param-mapping--select is-last' : 'param-mapping--select'
      }
      property={'id'}
      data={{ id: mappedParam.entry_id || null }}
      groupedOptions={true}
      update={update}
    />
  )
}

export const SettingsDynamicParamSelect = ({
  dynamicChoices = () => [],
  isDisabled = () => false,
}) => {
  const { dynamicParams } = dynamicChoices() || {}

  return (
    <>
      <h3 className="panel--section-title settings--label">
        Dynamic Parameters
      </h3>

      {dynamicParams.map(({ display_name, id, data_source_context_id }, i) => {
        return (
          <ParamMappingSelect
            key={slugify(`param-mapping-${data_source_context_id}-${id}`)}
            settingId={slugify(`param-mapping-${data_source_context_id}-${id}`)}
            isDisabled={isDisabled}
            dataSourceContextId={data_source_context_id}
            dataSourceParamId={id}
            settingLabel={display_name}
            isLast={i === dynamicParams.length - 1}
          />
        )
      })}
    </>
  )
}
